export const authConstants = {
  LOCAL_STORAGE_KEY: 'jc',
}
